/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDE2IDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTAgMEgxNlYyLjE2NjY3SDBWMFpNMCA0LjMzMzMzSDE2VjYuNUgwVjQuMzMzMzNaIiBmaWxsPSIjN0Y3RjdGIi8+PC9zdmc+";